import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  ["Do I need to create an account to buy?", "No. Revona uses simple guest checkout. You only provide your name, email and billing details — no sign up, login or password required."],
  ["How do I receive my product?", "After your payment is confirmed, you get an automatic secure download link on the confirmation page and by email receipt."],
  ["Which payment methods are supported?", "Credit/Debit card (Stripe), PayPal and bank transfer. Card and PayPal unlock the download instantly after confirmation; bank transfer unlocks after we verify the payment."],
  ["Is my payment secure?", "Yes. Payments are processed by secure hosted providers. We never collect or store card numbers, CVV or payment credentials."],
  ["How does bank transfer work?", "Your order is created as payment pending with our bank details. Once we confirm the transfer, your secure download is enabled and you receive an email."],
  ["Can I re-download my product?", "Yes, using your secure download link. If you lose it, contact support and we can resend or regenerate it."],
  ["Do you offer support?", "Yes — 24/7 computer, IT and networking technical support. Open a request on the Support page."],
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <span className="text-xs font-mono uppercase tracking-widest text-cyan-400">FAQ</span>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mt-2 mb-8">Frequently asked questions</h1>
      <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
        {faqs.map(([q, a], i) => (
          <AccordionItem key={i} value={`item-${i}`} className="tactical-card px-5 border-none">
            <AccordionTrigger className="text-white hover:no-underline text-left font-medium">{q}</AccordionTrigger>
            <AccordionContent className="text-slate-400">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
